<template>
    <v-layout class="ypo-auth-page">
        <v-flex>
            <login-card></login-card>
        </v-flex>
    </v-layout>
</template>
<script>
    import LoginCard from './LoginCard';
    import { appConstant } from "../../app.constant";

    export default {
        name: "LoginPage",
        components: {
            LoginCard,
        },
        data() {
            return {
                //TODO: remove this later - temp until mobile Apps stops using embedded browser
                isIosApp: navigator.userAgent.toLowerCase().includes(appConstant.YPO_IOS_CONNECT.toLowerCase()),
            };
        },
    };
</script>
<style lang="scss" scoped>
    @import '../../common/styles/ypo-auth';
</style>
